module.exports = __webpack_public_path__ + "img/p3.3f363bb7.svg";